import { HCAxiosRequestConfig } from './hcAxios'
import AES_RSA from './ASE_RSA'
import { getSecretKeyService } from 'core/service/hk-web/api'

let qs = {
  stringify: function (mapData: any, isEncode: boolean) {
    let str = ''
    for (let name in mapData) {
      let temp = ''
      //值为对象的先转测json字符串
      if (typeof mapData[name] === 'object') {
        temp = name + '=' + JSON.stringify(mapData[name]) + '&'
      } else {
        if (!isEncode) {
          temp = name + '=' + encodeURIComponent(mapData[name]) + '&'
        } else {
          temp = name + '=' + mapData[name] + '&'
        }
      }
      str += temp
    }
    return str.slice(0, -1)
  },
}

let getSecretKey: Promise<string> | undefined

const handleSignature = async (config: HCAxiosRequestConfig) => {
  if (!config?.options?.signature) return config
  if (config?.data?.signature) return config

  const timestamp = new Date().getTime()
  const data = config.data || {}
  data.timestamp = timestamp
  console.log('签名之前接口数据: ', config.url, data)
  const bizData = AES_RSA.encryptAES(data)
  let signature = ''

  // 这个是获取SecretKey常量的接口， 不需要签名
  if (getSecretKey === undefined) {
    getSecretKey = new Promise((resolve, reject) => {
      getSecretKeyService({
        randomKey: AES_RSA.encrypt(AES_RSA.RANDOMKEY) as string,
        randomIv: AES_RSA.encrypt(AES_RSA.RANDOMIV) as string,
        bizData: AES_RSA.encryptAES({
          bizType: 'GSIP',
          timestamp,
        }),
        signature: AES_RSA.len16Str(32),
        timestamp,
      })
        .then((res) => {
          resolve(JSON.parse(AES_RSA.decryptedAES(res.data.data)).ssk)
        })
        .catch((err) => {
          getSecretKey = undefined
          reject(err)
        })
    })
  }

  try {
    const secretKey = await getSecretKey
    signature = AES_RSA.hmacSHA256(secretKey, qs.stringify(AES_RSA.sortASCII(data), true))
    config.data = {
      randomKey: AES_RSA.encrypt(AES_RSA.RANDOMKEY),
      randomIv: AES_RSA.encrypt(AES_RSA.RANDOMIV),
      bizData: bizData,
      signature: signature,
      timestamp: timestamp,
    }
  } catch (err) {
    return Promise.reject(new Error('initSecretKeyError'))
  }
  return config
}

export default handleSignature
